import { CaretRight } from "@phosphor-icons/react";
import clsx from "clsx";
import { Link } from "react-router-dom";

import Checkbox from "common/components/ui/Checkbox";

import type { JSX, ReactNode } from "react";

type MobileListItemProps = {
  isSelected: boolean;
  toggleIsSelected: () => void;
  isSelecting: boolean;
  badgeContent: JSX.Element[];
  children: ReactNode;
} & ({ onClick: () => void; to?: never } | { onClick?: never; to: string });

export default function MobileSelectionListItem({
  toggleIsSelected,
  isSelected,
  isSelecting,
  children,
  badgeContent,
  to,
  onClick,
}: MobileListItemProps) {
  const hasItems = !!badgeContent.length;

  const wrapperStyles = clsx(
    "flex gap-x-1.5 p-2 mb-1 last:mb-0 border-b",
    hasItems ? "items-start" : "items-center",
    isSelected
      ? "bg-purple-50 border-b-transparent rounded-2xl"
      : "border-b-black-200",
  );

  const content = (
    <>
      <div className="flex flex-col gap-y-1.5 flex-1">
        <div className="flex items-center gap-x-1.5">
          {isSelecting && <Checkbox isStyleOnly checked={isSelected} />}
          {children}
          {!isSelecting && <CaretRight className="size-4 ml-auto" />}
        </div>

        {/* Tags */}
        {hasItems && (
          <div className="flex ml-9 gap-1.5 mt-1.5 flex-wrap">
            {badgeContent}
          </div>
        )}
      </div>
    </>
  );

  if (isSelecting || !to) {
    return (
      <button
        type="button"
        className={wrapperStyles}
        onClick={isSelecting ? toggleIsSelected : onClick}
      >
        {content}
      </button>
    );
  }

  return (
    <Link className={wrapperStyles} to={to}>
      {content}
    </Link>
  );
}
